import { render, staticRenderFns } from "./GenresManagement.vue?vue&type=template&id=128adfbe&scoped=true&"
import script from "./GenresManagement.vue?vue&type=script&lang=js&"
export * from "./GenresManagement.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&lang=css&"
import style1 from "./GenresManagement.vue?vue&type=style&index=1&id=128adfbe&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "128adfbe",
  null
  
)

export default component.exports